(function (app) {

    app.constant("fundsOriginationTypes",
    [
        {
            Label:
                "Funds are sitting in the client's checking/savings account or the client has a check from the company. The check is made payable to the client.",
            Value: "ExistingCheckToClient"
        },
        {
            Label: "The company will be sending the client a check. The check will be made payable to the client.",
            Value: "ExpectedCheckToClient"
        },
        {
            Label: "The company will be sending a check to the carrier. The check will be made payable to the carrier.",
            Value: "ExpectedCheckToCarrier"
        }
    ]);

})(window.app); //jshint ignore:line